// extracted by mini-css-extract-plugin
export default {"alignleft":"alignleft-91fb","center":"center-93e8"};